import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response, RequestOptions, Headers} from '@angular/http';
import { environment } from '../../../environments/environment';
// import * as $ from 'jquery';
declare var $ : any;
import swal from 'sweetalert2';
// import { RRFormService } from '../../r-r-form.service';
import { NgxSpinnerService } from 'ngx-spinner';

const authToken = localStorage.getItem('currentUser');


@Component({
	selector: 'app-voucher-report',
	templateUrl: './voucher-report.component.html',
	styleUrls: ['./voucher-report.component.css']
})
export class VoucherReportComponent implements OnInit {

	date_range:Date=new Date(Date.now());

	url = environment.url
	reportForm : FormGroup;
	query : any = null;
	export_query : any = null;
	response : any = null;
	report_data : any[] = [];
	rr_number :any[] = [];

	flat_info_table :any[] = [];
	total_weight : number = null;
	total_freight : number = null;
	role:any;
	username:any;


	// Product properties
	productDropdownList = [];
	productSelectedItems = [];
	productDropdownSettings = { 
		singleSelection: false, 
		text:"Select Product",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_product = [];

	
	// Station properties
	stationDropdownList = [];
	stationSelectedItems = [];
	stationDropdownSettings = {
		singleSelection: false, 
		text:"Select Station",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_station = [];

	// truck Driver
	truckDriverDropdownList = [];
	truckDriverSelectedItems = [];
	truckDriverDropdownSettings = {
		singleSelection: false, 
		text:"Select Truck Driver",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_truck_driver = [];

	// lr number
	lrNumberDropdownList = [];
	lrNumberSelectedItems = [];
	lrNumberDropdownSettings = {
		singleSelection: false, 
		text:"Select LR no",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_lr_number = [];

	// Destination properties
	destinationDropdownList = [];
	destinationSelectedItems = [];
	destinationDropdownSettings = {
		singleSelection: false, 
		text:"Select Destination",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_destination = [];

	// Truck Number properties
	truckNumberDropdownList = [];
	truckNumberSelectedItems = [];
	truckNumberDropdownSettings = {
		singleSelection: false, 
		text:"Select Truck Number",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_truck_number = [];

	


	constructor( private http : Http, private spinner: NgxSpinnerService) { }

	ngOnInit() {

		// this.getRRNumber();
		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);
		this.role=temp["role"];
		this.username = temp ["username"];
		
		this.reportForm = new FormGroup({
			"rr_number" : new FormControl(null, Validators.required),
			"date_range" : new FormControl(null, Validators.required),			
			"product" : new FormControl(null, Validators.required),		 
			"station" : new FormControl(null, Validators.required),		 
			"truck_driver" : new FormControl(null, Validators.required),		 
			"lr_number" : new FormControl(null, Validators.required),
			"destination" : new FormControl(null, Validators.required),	 
			"truck_number" : new FormControl(null, Validators.required)	 
		});

	

		this.getFilters();



		console.log(this.reportForm.value);	
	};


	

	
	// *************** Product Functions ***************

	onProductSelect(item:any){
		console.log(item);
		console.log(this.productSelectedItems);
		this.convertProductOptionsToString();
	}

	OnProductDeSelect(item:any){
		console.log(item);
		console.log(this.productSelectedItems);
		this.convertProductOptionsToString();
	}

	onSelectAllProduct(items: any){
		console.log(items);
		this.convertProductOptionsToString();
	}

	onDeSelectAllProduct(items: any){
		console.log(items);
		this.convertProductOptionsToString();
	}

	convertProductOptionsToString(){
		this.post_product=[];
		for ( var i=0; i<this.productSelectedItems.length; i++ ){
			this.post_product.push(this.productSelectedItems[i]["itemName"]);
		}
		console.log(this.post_product);
	}

	
	// *************** Station Functions ***************

	onStationSelect(item:any){
		console.log(item);
		console.log(this.stationSelectedItems);
		this.convertStationOptionsToString();
	}

	OnStationDeSelect(item:any){
		console.log(item);
		console.log(this.stationSelectedItems);
		this.convertStationOptionsToString();
	}

	onSelectAllStation(items: any){
		console.log(items);
		this.convertStationOptionsToString();
	}

	onDeSelectAllStation(items: any){
		console.log(items);
		this.convertStationOptionsToString();
	}

	convertStationOptionsToString(){
		this.post_station=[];
		for ( var i=0; i<this.stationSelectedItems.length; i++ ){
			this.post_station.push(this.stationSelectedItems[i]["itemName"]);
		}
		console.log(this.post_station);
	}

	// *************** truck driver Functions ***************

	truckDriverSelect(item:any){
		console.log(item);
		console.log(this.truckDriverSelectedItems);
		this.convertTruckDriverOptionsToString();
	}

	truckDriverDeSelect(item:any){
		console.log(item);
		console.log(this.truckDriverSelectedItems);
		this.convertTruckDriverOptionsToString();
	}

	onSelectAllTruckDriver(items: any){
		console.log(items);
		this.convertTruckDriverOptionsToString();
	}

	onDeSelectAllTruckDriver(items: any){
		console.log(items);
		this.convertTruckDriverOptionsToString();
	}

	convertTruckDriverOptionsToString(){
		this.post_truck_driver=[];
		for ( var i=0; i<this.truckDriverSelectedItems.length; i++ ){
			this.post_truck_driver.push(this.truckDriverSelectedItems[i]["itemName"]);
		}
		console.log(this.post_truck_driver);
	}

	// *************** Lr Number Functions ***************

	onLrSelect(item:any){
		console.log(item);
		console.log(this.lrNumberSelectedItems);
		this.convertLrOptionsToString();
	}

	OnLrDeSelect(item:any){
		console.log(item);
		console.log(this.lrNumberSelectedItems);
		this.convertLrOptionsToString();
	}

	onSelectAllLr(items: any){
		console.log(items);
		this.convertLrOptionsToString();
	}

	onDeSelectAllLr(items: any){
		console.log(items);
		this.convertLrOptionsToString();
	}

	convertLrOptionsToString(){
		this.post_lr_number=[];
		for ( var i=0; i<this.lrNumberSelectedItems.length; i++ ){
			this.post_lr_number.push(this.lrNumberSelectedItems[i]["itemName"]);
		}
		console.log(this.post_lr_number);
	}

	// *************** Destination Functions ***************

	onDestinationSelect(item:any){
		console.log(item);
		console.log(this.destinationSelectedItems);
		this.convertDestinationOptionsToString();
	}

	OnDestinationDeSelect(item:any){
		console.log(item);
		console.log(this.destinationSelectedItems);
		this.convertDestinationOptionsToString();
	}

	onSelectAllDestination(items: any){
		console.log(items);
		this.convertDestinationOptionsToString();
	}

	onDeSelectAllDestination(items: any){
		console.log(items);
		this.convertDestinationOptionsToString();
	}

	convertDestinationOptionsToString(){
		this.post_destination=[];
		for ( var i=0; i<this.destinationSelectedItems.length; i++ ){
			this.post_destination.push(this.destinationSelectedItems[i]["itemName"]);
		}
		console.log(this.post_destination);
	}

	// *************** TruckNumber Functions ***************

	onTruckNumberSelect(item:any){
		console.log(item);
		console.log(this.truckNumberSelectedItems);
		this.convertTruckNumberOptionsToString();
	}

	OnTruckNumberDeSelect(item:any){
		console.log(item);
		console.log(this.truckNumberSelectedItems);
		this.convertTruckNumberOptionsToString();
	}

	onSelectAllTruckNumber(items: any){
		console.log(items);
		this.convertTruckNumberOptionsToString();
	}

	onDeSelectAllTruckNumber(items: any){
		console.log(items);
		this.convertTruckNumberOptionsToString();
	}

	convertTruckNumberOptionsToString(){
		this.post_truck_number=[];
		for ( var i=0; i<this.truckNumberSelectedItems.length; i++ ){
			this.post_truck_number.push(this.truckNumberSelectedItems[i]["itemName"]);
		}
		console.log(this.post_truck_number);
	}

	




	getFilters(){
		console.log(this.reportForm.value);

		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });

		const path = this.url + '/voucher/filters';
		this.http.get(path, options)
		.subscribe(res=>{
			console.log(res.json());
			
			this.report_data = res.json();

			this.fillProductFilters(this.report_data["filters"]["product"]);
			this.fillStationFilters(this.report_data["filters"]["station"]);
			this.fillTruckDriverFilters(this.report_data["filters"]["truck_driver"]);
			this.fillLrNumberFilters(this.report_data["filters"]["lr_number"]);
			this.fillDestinationFilters(this.report_data["filters"]["destination"]);
			this.fillTruckNumberFilters(this.report_data["filters"]["truck_number"]);
			
				
			console.log(this.report_data)
		});
	
	};

	fillProductFilters(product_options){
		this.productDropdownList = [];
		for ( var i=0; i<product_options.length; i++ ){
			this.productDropdownList.push({"id" :i, "itemName" : product_options[i]});
		}
	};

	

	fillStationFilters(station_options){
		this.stationDropdownList = [];
		for ( var i=0; i<station_options.length; i++ ){
			this.stationDropdownList.push({"id" :i, "itemName" : station_options[i]});
		}
	};

	fillTruckDriverFilters(truck_driver_options){
		this.truckDriverDropdownList = [];
		for ( var i=0; i<truck_driver_options.length; i++ ){
			this.truckDriverDropdownList.push({"id" :i, "itemName" : truck_driver_options[i]});
		}
	};

	fillLrNumberFilters(lr_number_options){
		this.lrNumberDropdownList = [];
		for ( var i=0; i<lr_number_options.length; i++ ){
			this.lrNumberDropdownList.push({"id" :i, "itemName" : lr_number_options[i]});
		}
	};

	fillDestinationFilters(destination_options){
		this.destinationDropdownList = [];
		for ( var i=0; i<destination_options.length; i++ ){
			this.destinationDropdownList.push({"id" :i, "itemName" : destination_options[i]});
		}
	};

	

	fillTruckNumberFilters(truck_number_options){
		this.truckNumberDropdownList = [];
		for ( var i=0; i<truck_number_options.length; i++ ){
			this.truckNumberDropdownList.push({"id" :i, "itemName" : truck_number_options[i]});
		}
	};

	

	filteredData(){

		console.log(this.reportForm.value.date_range)

		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });

		this.query = this.queryBuilder();
		this.export_query = this.query;
		console.log(this.query);

		const path = this.url + '/voucher/reports';
		this.http.post(path, this.query, options)
		.subscribe(res=>{
			this.report_data = res.json();	
			console.log(this.report_data);
			if(this.report_data["voucher_list"].length == 0){
				swal('Result Not Found', 'Records for the options selected may not be available', 'warning');
			}
			this.total_freight = this.report_data["total_freight"]
			this.total_weight = this.report_data["total_weight"]
			console.log(this.report_data);
			this.flat_info_table = this.report_data["voucher_list"];

		});

	};

	queryBuilder(){
		var post_query={}
		console.log("date==",this.reportForm.value.date_range);
		var s_date = new Date(this.reportForm.value.date_range).getTime();
		console.log(typeof s_date);
		console.log(" Date Epoch :", (s_date/1000));
		
		

		if(!this.reportForm.get("date_range").value){
			console.log("empty date_range")
			delete  post_query["date_range"]
		}
		else{
			post_query["date_range"] = this.reportForm.get("date_range").value;
		}

		// Product
		if(this.reportForm.get("product").value == 0 ){
			console.log("empty product")
			delete post_query["product"]
		}
		else{
			post_query["product"] = this.post_product;
		}

		
		// Station
		if(this.reportForm.get("station").value == 0 ){
			console.log("empty station")
			delete post_query["station"]
		}
		else{
			post_query["station"] = this.post_station;
		}

		// Truck Driver
		if(this.reportForm.get("truck_driver").value == 0 ){
			console.log("empty truck driver")
			delete post_query["truck_driver"]
		}
		else{
			post_query["truck_driver"] = this.post_truck_driver;
		}

		// lr no
		if(this.reportForm.get("lr_number").value == 0 ){
			console.log("empty lr number")
			delete post_query["lr_number"]
		}
		else{
			post_query["lr_number"] = this.post_lr_number;
		}

		// Destination
		if(this.reportForm.get("destination").value == 0 ){
			console.log("empty destination")
			delete post_query["destination"]
		}
		else{
			post_query["destination"] = this.post_destination;
		}

		// Truck Number
		if(this.reportForm.get("truck_number").value == 0 ){
			console.log("empty truck_number")
			delete post_query["truck_number"]
		}
		else{
			post_query["truck_number"] = this.post_truck_number;
		}

		

		console.log(post_query);
		return post_query

		
	};

	exportdData(){
		this.spinner.show();
		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });
		
		const path = this.url + "/reports/lr/export";
		this.http.post(path, this.export_query, options)
		.subscribe(res=>{
			this.response = res.json();	
			console.log(res.json())
			if(this.response["status"]){
				swal('Report Exported Successfully', 'Excel file is mailed to your register email-id', 'success');
				this.spinner.hide();
			}
			else{
				swal('Oops!', 'Something went wrong on the page!', 'error');
				this.spinner.hide();
			}
		},error=>{
			swal('Oops!', 'Please select options for Excel file', 'error');
			this.spinner.hide();
		});
	};



}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/reports/voucher-report/voucher-report.component.ts